(function () {
  var root = document.querySelector('[data-bp-buy]');
  if (!root) return;
  var form = root.querySelector('[data-bp-form]');
  var atc = root.querySelector('[data-bp-atc]');
  var planInput = root.querySelector('[data-bp-plan-input]');
  var opts = root.querySelectorAll('[data-bp-opt]');
  var select = root.querySelector('[data-bp-plan]');
  var first = root.querySelector('[data-bp-first]');
  var err = root.querySelector('[data-bp-err]');
  var start = root.querySelector('[data-bp-start]');
  var dlg = root.querySelector('[data-bp-modal]');
  var sticky = document.querySelector('[data-bp-sticky]');

  function setMode(mode) {
    opts.forEach(function (o) {
      var on = o.getAttribute('data-bp-opt') === mode;
      o.classList.toggle('is-on', on);
      o.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (planInput) planInput.disabled = mode !== 'sub';
    syncStickyPrice(mode);
  }

  function syncStickyPrice(mode) {
    if (!sticky) return;
    var sp = sticky.querySelector('[data-bp-sticky-price]');
    if (!sp) return;
    if (mode === 'sub') {
      if (first) sp.textContent = first.textContent.trim();
    } else {
      var one = root.querySelector('[data-bp-opt="one"] .bp-opt__p');
      if (one) sp.textContent = one.textContent.trim();
    }
  }

  opts.forEach(function (o) {
    o.addEventListener('click', function (e) {
      if (e.target.closest('select, a, button:not([data-bp-opt])')) return;
      setMode(o.getAttribute('data-bp-opt'));
    });
    o.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target === o) {
        e.preventDefault();
        setMode(o.getAttribute('data-bp-opt'));
      }
    });
  });

  if (select && planInput) {
    select.addEventListener('change', function () {
      var o = select.options[select.selectedIndex];
      planInput.value = select.value;
      if (first && o && o.getAttribute('data-money')) first.textContent = o.getAttribute('data-money');
      setMode('sub');
    });
  }

  if (start && form && planInput) {
    start.addEventListener('click', function () {
      setMode('sub');
      start.disabled = true;
      if (err) err.hidden = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1, selling_plan: Number(planInput.value) }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart.'); });
          window.location.href = '/checkout';
        })
        .catch(function (e) {
          if (err) { err.textContent = e.message || 'Something went wrong. Please try again.'; err.hidden = false; }
          start.disabled = false;
        });
    });
  }

  root.querySelectorAll('[data-bp-more]').forEach(function (b) {
    b.addEventListener('click', function () { if (dlg && dlg.showModal) dlg.showModal(); });
  });
  if (dlg) dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });

  if (sticky && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var show = !en.isIntersecting;
      sticky.hidden = !show;
      document.body.classList.toggle('bp-has-sticky', show);
    }).observe(atc);
    sticky.querySelector('button').addEventListener('click', function () { atc.click(); });
  }

  setMode('one');
})();